const generateActionFactory = prefix => actionName => [
  `${prefix}${actionName}`,
  `${prefix}${actionName}_SUCCESS`,
  `${prefix}${actionName}_FAIL`
]

export default generateActionFactory
